import { onMounted } from 'vue'

export function useTableColumnHover() {
  const setupTableColumnHover = () => {
    const initTableHover = (table) => {
      if (table.dataset.columnHoverInitialized === 'true') return
      table.dataset.columnHoverInitialized = 'true'
      
      let currentColumnIndex = null
      
      const handleMouseOver = (e) => {
        const cell = e.target.closest('th, td')
        if (!cell || !table.contains(cell)) {
          if (currentColumnIndex !== null) {
            const allCells = table.querySelectorAll(`th:nth-child(${currentColumnIndex + 1}), td:nth-child(${currentColumnIndex + 1})`)
            allCells.forEach(c => c.classList.remove('column-hover'))
            currentColumnIndex = null
          }
          return
        }
        
        const row = cell.parentElement
        const columnIndex = Array.from(row.children).indexOf(cell)
        
        if (currentColumnIndex === columnIndex) return
        
        if (currentColumnIndex !== null) {
          const prevCells = table.querySelectorAll(`th:nth-child(${currentColumnIndex + 1}), td:nth-child(${currentColumnIndex + 1})`)
          prevCells.forEach(c => c.classList.remove('column-hover'))
        }
        
        currentColumnIndex = columnIndex
        const allCells = table.querySelectorAll(`th:nth-child(${columnIndex + 1}), td:nth-child(${columnIndex + 1})`)
        allCells.forEach(c => c.classList.add('column-hover'))
      }
      
      table.addEventListener('mouseover', handleMouseOver)
      table.addEventListener('mouseleave', () => {
        if (currentColumnIndex !== null) {
          const allCells = table.querySelectorAll(`th:nth-child(${currentColumnIndex + 1}), td:nth-child(${currentColumnIndex + 1})`)
          allCells.forEach(c => c.classList.remove('column-hover'))
          currentColumnIndex = null
        }
      })
    }
    
    const tables = document.querySelectorAll('.table')
    tables.forEach(initTableHover)
    
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            const newTables = node.querySelectorAll ? node.querySelectorAll('.table') : []
            newTables.forEach(initTableHover)
            if (node.classList && node.classList.contains('table')) {
              initTableHover(node)
            }
          }
        })
      })
    })
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    })
  }

  onMounted(() => {
    setupTableColumnHover()
  })

  return {
    setupTableColumnHover
  }
}

